import * as React from "react";
import Avatar from "@mui/material/Avatar";

function stringToColor(string) {
  let hash = 0;
  let i;

  /* eslint-disable no-bitwise */
  for (i = 0; i < string.length; i += 1) {
    hash = string.charCodeAt(i) + ((hash << 5) - hash);
  }

  let color = "#";

  for (i = 0; i < 3; i += 1) {
    const value = (hash >> (i * 8)) & 0xff;
    color += `00${value.toString(16)}`.slice(-2);
  }
  /* eslint-enable no-bitwise */

  return color;
}

const getLetters = (name) => {
  const parts = (name || "").trim().split(/\s+/).filter(Boolean);
  if (parts.length === 0) return "";
  if (parts.length === 1) return parts[0][0];
  return `${parts[0][0]}${parts[1][0]}`;
};
export default function PersonAvatar(props) {
  return (
    <div
      className={
        `inline-flex overflow-hidden relative justify-center items-center ${
          props.size === "sm"
            ? "w-7 h-7 text-[10px]"
            : props.view === "daily"
            ? "w-8 h-8 text-xs"
            : "w-10 h-10"
        } ` +
        props.bgColor +
        " rounded-full"
      }
    >
      <span className="text-white">{getLetters(props.name)}</span>
    </div>
  );
}
